import React, { Suspense } from 'react'
import Modal, { Header } from 'src/components/theme/Models/Modal'
import Body, { RelationshipsModalToggle, RelationshipsModalToggleProps } from './Body'
import { CardBody } from 'reactstrap'
import Loading from './Loading'

interface RelationshipsModalProps {
  toggle: RelationshipsModalToggle
  lookupId: string
  optionId?: string
  relationshipModel?: string
}

const RelationshipsModal: React.FC<RelationshipsModalProps> = (props) => {
  const { toggle, lookupId, relationshipModel, optionId } = props
  const isOpen = relationshipModel !== undefined && optionId !== undefined

  return (
    <Modal
      title='Relationships Lookup Option'
      isOpen={isOpen}
      toggle={() => toggle(undefined)}
    >
      <Header title='Relationships Lookup Option' />
      {isOpen && (
        <CardBody className='p-3 d-flex h-100 align-items-start flex-column overflow-auto'>
          <Suspense fallback={<Loading />}>
            <Body
              toggle={toggle}
              relationshipModel={relationshipModel}
              lookupId={lookupId}
              optionId={optionId}
            />
          </Suspense>
        </CardBody>
      )}
    </Modal>
  )
}

export default RelationshipsModal
export type { RelationshipsModalToggle, RelationshipsModalToggleProps }
